import {combineReducers} from "redux";
import userReducer from "./user";
import resourceReducer from "./resource";
import secondResourceReducer from "./secondResource";
import uiReducer from "./ui";
import dialogResourceReducer from "./dialogResource";
import messagesReducer from "./messaging";
import notificationsReducer from "../../package/notification/reducers/notifications";

const appReducer = combineReducers({
    user: userReducer,
    resource: resourceReducer,
    ui: uiReducer,
    secondResource: secondResourceReducer,
    dialogResource: dialogResourceReducer,
    messages: messagesReducer,
    notifications: notificationsReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        return {
            ui: {},
            user: {},
            resource: {},
            secondResource: {},
            dialogResource: {},
            messages: {},
            notifications: {}
        }
    }
    return appReducer(state, action);
};

export default rootReducer;